/** Default page size for task list table and Task Detail Quick Peek. */
export const DEFAULT_TASKLIST_ITEMS_PER_PAGE = 50;
